import { render, staticRenderFns } from "./PromoPage.vue?vue&type=template&id=8084d766&scoped=true"
import script from "./PromoPage.vue?vue&type=script&lang=js"
export * from "./PromoPage.vue?vue&type=script&lang=js"
import style0 from "./PromoPage.vue?vue&type=style&index=0&id=8084d766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8084d766",
  null
  
)

export default component.exports